export const Color ={
    blue:"#2874f0",
    black:'#1e1e1e',
    BananaYellow:'#F8E831',
    TrueBlue:'#047BD5'
}